// @flow
import React from "react";
import type { GazelleData, GazelleObject } from "../../types/gazelle.js";
import { findRef } from "../../utils/gazelle.js";
import "./HtmlText.scss";

type HtmlTextIframeProps = {
  headHtml: string,
  bodyHtml: string
};

class HtmlTextIframe extends React.Component {
  state: {
    iframeHeight: number
  };
  props: HtmlTextIframeProps;
  constructor(props: HtmlTextIframeProps) {
    super(props);
    this.state = {
      iframeHeight: 0
    };
    (this: any).onIframeLoad = this.onIframeLoad.bind(this);
  }

  onIframeLoad(evt: Event) {
    var iframeDocumentBody: HTMLElement = (evt.target: any).contentWindow
      .document.body;

    this.setState({ iframeHeight: iframeDocumentBody.scrollHeight });
  }

  render() {
    const iframeSrc = `
      <html>
        <head>${this.props.headHtml}</head>
        <body>${this.props.bodyHtml}</body>
      </html>
    `;
    return (
      <iframe
        className="gazelle-preview__html-text-iframe"
        style={{ height: this.state.iframeHeight }}
        scrolling="no"
        frameBorder="0"
        srcDoc={iframeSrc}
        onLoad={this.onIframeLoad}
      />
    );
  }
}

export default function HtmlText(props: {
  gazelleData: GazelleData,
  htmlTextData: GazelleObject
}) {
  const { gazelleData, htmlTextData } = props;
  const attributes = htmlTextData.get("attributes");
  const htmlHeadData = findRef(gazelleData, attributes.get("head"));
  if (htmlHeadData == null) {
    return null;
  }

  return (
    <HtmlTextIframe
      headHtml={htmlHeadData.getIn(["attributes", "head-html"])}
      bodyHtml={attributes.get("body-html")}
    />
  );
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/gazelle/HtmlText.js